import React from "react";
import { observer } from "mobx-react";
import classNames from "classnames";
import BaseModal from "@app/components/modal";
import PdfViewer from "./index";

import "./style/modal.global.scss";
import "./style/modal.scoped.scss";

const Modal = observer(
    ({
        fileId,
        title,
        goto,
        focus,
        onClose,
        container,
        documentId,
        articleId,
        stage,
        articleType,
        onBookmark,
        onComment,
    }) => {
        return (
            <BaseModal
                title={title ?? ""}
                visible={true}
                onCancel={onClose}
                footer={null}
                width={1000}
                height="50vh"
                maskClosable={false}
                mask={false}
                className={classNames("pdf-modal-viewer")}
                wrapClassName="pdf-modal-viewer-wrap"
                getContainer={() => container}
            >
                <PdfViewer
                    fileId={fileId}
                    focus={focus}
                    goto={goto}
                    documentId={documentId}
                    articleId={articleId}
                    stage={stage}
                    articleType={articleType}
                    onBookmark={onBookmark}
                    onComment={onComment}
                ></PdfViewer>
            </BaseModal>
        );
    },
);

export default Modal;
